(function () {
  function initCountdown() {
    var timerWrapper = document.querySelector('.custom-timer-wrapper');
    if (!timerWrapper) return;

    var second = 1000;
    var minute = second * 60;
    var hour = minute * 60;
    var day = hour * 24;

    var yearEl = document.querySelector('.event_year');
    var monthEl = document.querySelector('.event_month');
    var dateEl = document.querySelector('.event_date');
    var hourEl = document.querySelector('.event-end-hour');
    if (!yearEl || !monthEl || !dateEl || !hourEl) return;

    var endYear = parseInt(yearEl.dataset.value, 10);
    var endMonth = parseInt(monthEl.dataset.value, 10);
    var endDate = parseInt(dateEl.dataset.value, 10);
    var endHour = parseInt(hourEl.dataset.value, 10);

    if ([endYear, endMonth, endDate, endHour].some(function (n) { return Number.isNaN(n); })) {
      return;
    }

    var countDown = new Date(endYear, endMonth, endDate, endHour).getTime();
    var useStartGate = timerWrapper.classList.contains('start_calendar');
    var startDown = null;

    if (useStartGate) {
      var startYear = parseInt(yearEl.dataset.startValue, 10);
      var startMonth = parseInt(monthEl.dataset.startValue, 10);
      var startDate = parseInt(dateEl.dataset.startValue, 10);
      var startHour = parseInt(hourEl.dataset.startValue, 10);
      if (![startYear, startMonth, startDate, startHour].some(function (n) { return Number.isNaN(n); })) {
        startDown = new Date(startYear, startMonth, startDate, startHour).getTime();
      }
    }

    var dayEls = document.querySelectorAll('.js-timer-days');
    var hourEls = document.querySelectorAll('.js-timer-hours');
    var minuteEls = document.querySelectorAll('.js-timer-minutes');
    var secondEls = document.querySelectorAll('.js-timer-seconds');
    var numEls = document.querySelectorAll('.hc_cd_timernum');
    var loadingEls = document.querySelectorAll('.timer_loading');

    var lastSecondKey = null;

    function setText(nodes, value) {
      nodes.forEach(function (item) {
        var strong = item.querySelector('strong');
        if (strong) strong.textContent = value;
      });
    }

    function nowInLA() {
      var formattedDate = new Date().toLocaleString('en-US', { timeZone: 'America/Los_Angeles' });
      return new Date(formattedDate).getTime();
    }

    function tick() {
      var nowtime = nowInLA();

      // Wait until start time if "Start calendar" is enabled — keep polling.
      if (startDown != null && startDown - nowtime >= 0) {
        return true;
      }

      timerWrapper.classList.remove('hidden');

      var distance = countDown - nowtime;
      if (distance <= 0) {
        timerWrapper.classList.add('hidden');
        return false;
      }

      var totalDays = Math.floor(distance / day);
      var remainingHours = Math.floor((distance % day) / hour);
      var remainingMinutes = Math.floor((distance % hour) / minute);
      var remainingSeconds = Math.floor((distance % minute) / second);
      var secondKey =
        totalDays + '-' + remainingHours + '-' + remainingMinutes + '-' + remainingSeconds;

      if (secondKey === lastSecondKey) return true;
      lastSecondKey = secondKey;

      numEls.forEach(function (item) {
        item.classList.remove('hidden');
      });
      loadingEls.forEach(function (item) {
        item.classList.add('hidden');
      });

      setText(dayEls, totalDays);
      setText(hourEls, remainingHours);
      setText(minuteEls, remainingMinutes);
      setText(secondEls, remainingSeconds);
      return true;
    }

    function scheduleTick() {
      if (!tick()) return;
      window.setTimeout(scheduleTick, 1000);
    }

    if (tick()) scheduleTick();
  }

  if (document.readyState === 'complete') {
    initCountdown();
  } else {
    window.addEventListener('load', initCountdown, { once: true });
  }
})();
